module.exports = __webpack_public_path__ + "img/user-logo.6a63a6f8.jpg";